module.exports = __webpack_public_path__ + "static/media/no-tasks-v2.4b504ead.svg";